import { useMutation } from '@tanstack/react-query';
import { toastErrorConfig } from 'lib/reactToastify/config';
import { toast } from 'react-toastify';

import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { Messages } from 'features/chat/config/types/Message';
import { EditMessage } from 'features/chat/config/types/ParentMessage';
import { useChatInterlocutorContext } from 'features/chat/context/chatInterlocutor';
import { useChatQueryActions } from 'features/chat/hooks/useChatActions';

export const useChatMessageEditMutation = () => {
  const { chatId } = useChatInterlocutorContext();
  const { request } = useMutationHTTPRequest();

  const { cancelChatQueries, getChatQuery, updateChatQuery } =
    useChatQueryActions();

  return useMutation(
    async ({
      messageId,
      text,
      replyTo,
      attachments,
      linkPreview,
    }: Omit<EditMessage, 'fromUserId' | 'scheduledFor' | 'deleted'>) =>
      request({
        url: `/api/chats/${chatId}/messages/${messageId}/edit`,
        body: {
          text,
          replyTo,
          attachments,
          linkPreview,
        },
      }),
    {
      onMutate: async () => {
        await cancelChatQueries();

        const previousValue = getChatQuery();

        return { previousValue };
      },
      onError: (err, _, context) => {
        const previousValue = (context as { previousValue: Messages })
          ?.previousValue;

        updateChatQuery(previousValue);

        toast.error(
          "There's an error with editing the message. Please try again later.",
          toastErrorConfig
        );

        logError(err);
      },
    }
  );
};
